import { useMemo, useState } from "react";
import { ListingCard } from "./ListingCard";
import { WRAP, GRID } from "./MarketSection";
import { resolveImg } from "@/lib/marketplaceTrack";

export function CategoryBrowser({ categories, listings, catName }) {
  const [active, setActive] = useState(null);
  const visible = categories.filter((c) => c.count > 0);
  const items = useMemo(() => listings.filter((l) => l.category === active), [listings, active]);
  if (!visible.length) return null;

  return (
    <section id="categories" data-testid="mkt-section-categories" className="scroll-mt-24 border-y border-white/5 bg-[#0D0D0D]">
      <div className={`${WRAP} py-20 lg:py-24`}>
        <div className="label-eyebrow mb-3">02 · Categories</div>
        <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.05] mb-10">
          Browse by <span className="italic text-[#D4AF37]">calling</span>
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 lg:gap-4">
          {visible.map((c) => (
            <button key={c.key} type="button" onClick={() => setActive(active === c.key ? null : c.key)}
              data-testid={`mkt-cat-${c.key}`} aria-pressed={active === c.key}
              className={`group relative aspect-[16/10] overflow-hidden rounded-lg border text-left transition-colors ${active === c.key ? "border-[#D4AF37]" : "border-white/10 hover:border-white/30"}`}>
              {c.image_url && <img src={resolveImg(c.image_url)} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-60 group-hover:scale-105 transition-[transform,opacity] duration-700" />}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 p-4">
                <div className="text-white font-serif-display text-lg lg:text-xl leading-tight">{c.name}</div>
                <div className="text-[10px] tracking-widest uppercase text-[#D4AF37] mt-1">{c.count} item{c.count === 1 ? "" : "s"}</div>
              </div>
            </button>
          ))}
        </div>
        {active && (
          <div className="mt-10" data-testid="mkt-cat-results">
            <div className="flex items-center justify-between mb-6">
              <div className="text-sm text-neutral-300">Showing <span className="text-[#D4AF37]">{catName(active)}</span></div>
              <button type="button" onClick={() => setActive(null)} data-testid="mkt-cat-clear" className="text-xs tracking-widest uppercase text-neutral-400 hover:text-white">Clear</button>
            </div>
            <div className={GRID}>
              {items.map((l, i) => <ListingCard key={l.id} listing={l} categoryName={catName(l.category)} index={i} />)}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
